document.addEventListener("DOMContentLoaded", async function () {
  // Guard check: Run checkout logic ONLY if checkout wrapper exists on current page
  const shippingRatesContainer = document.getElementById("shipping-rates-container");
  const cartItemsContainer = document.getElementById("abouche3le-cart-items");
  const submitOrderBtn = document.getElementById("submit-order-btn");

  if (!shippingRatesContainer && !cartItemsContainer && !submitOrderBtn) {
    return; // Exit cleanly on standard theme pages (Homepage, Collection, Product, etc.)
  }

  const summarySubtotal = document.getElementById("summary-subtotal");
  const summaryShipping = document.getElementById("summary-shipping");
  const summaryTotal = document.getElementById("summary-total");
  const btnTotalPrice = document.getElementById("btn-total-price");
  
  const whishRadio = document.getElementById("payment-whish");
  const shamcashRadio = document.getElementById("payment-shamcash");
  const codRadio = document.getElementById("payment-cod");
  const whishBox = document.getElementById("whish-instructions-box");
  const shamcashBox = document.getElementById("shamcash-instructions-box");
  const receiptBox = document.getElementById("receipt-upload-box");
  const receiptFileInput = document.getElementById("receipt-file-input");
  const receiptFileLabel = document.getElementById("receipt-file-label");
  
  const whishTotalDisplay = document.getElementById("whish-total-display");
  const shamcashTotalDisplay = document.getElementById("shamcash-total-display");
  const whishHashInput = document.getElementById("whish-hash-input");
  const shamcashHashInput = document.getElementById("shamcash-hash-input");

  if (whishHashInput) whishHashInput.value = "47c28d780015082e405278c669c7b6f3";
  if (shamcashHashInput) shamcashHashInput.value = "9b41e32f882109c1150498b77a1e2f91";

  document.querySelectorAll('img[alt*="Whish QR"]').forEach(img => {
    img.src = "https://cdn.shopify.com/s/files/1/0952/7646/6540/files/whish-qr.jpg?v=1787771879";
  });
  document.querySelectorAll('img[alt*="ShamCash QR"]').forEach(img => {
    img.src = "https://cdn.shopify.com/s/files/1/0952/7646/6540/files/shamcash-qr.jpg?v=1787772004";
  });

  let cartData = null;
  let selectedShippingRate = 5.00;
  let selectedShippingName = "Standard Delivery";

  if (receiptFileInput && receiptFileLabel) {
    receiptFileInput.addEventListener('change', (e) => {
      if (e.target.files.length > 0) {
        receiptFileLabel.textContent = `Attached: ${e.target.files[0].name}`;
        receiptFileLabel.classList.add('text-emerald-700', 'font-bold');
        if (receiptBox) receiptBox.classList.remove('border-red-400');
      }
    });
  }

  function updateTotals() {
    if (!cartData) return;
    const subtotal = (cartData.items_subtotal_price || cartData.total_price || 0) / 100;
    const total = subtotal + selectedShippingRate;

    if (summarySubtotal) summarySubtotal.textContent = `$${subtotal.toFixed(2)}`;
    if (summaryShipping) summaryShipping.textContent = `$${selectedShippingRate.toFixed(2)}`;
    if (summaryTotal) summaryTotal.textContent = `$${total.toFixed(2)}`;
    if (btnTotalPrice) btnTotalPrice.textContent = `$${total.toFixed(2)}`;
    if (whishTotalDisplay) whishTotalDisplay.textContent = `$${total.toFixed(2)}`;
    if (shamcashTotalDisplay) shamcashTotalDisplay.textContent = `$${total.toFixed(2)}`;
  }

  function handlePaymentToggle() {
    if (whishBox) whishBox.classList.add('hidden');
    if (shamcashBox) shamcashBox.classList.add('hidden');
    if (receiptBox) receiptBox.classList.add('hidden');

    const countrySelectEl = document.getElementById('ship-country');
    const countrySelected = countrySelectEl ? countrySelectEl.value : 'Lebanon';
    
    if (countrySelected === 'Syria') {
      if (shamcashBox) shamcashBox.classList.remove('hidden');
      if (receiptBox) receiptBox.classList.remove('hidden');
      return;
    }

    if (whishRadio && whishRadio.checked) {
      if (whishBox) whishBox.classList.remove('hidden');
      if (receiptBox) receiptBox.classList.remove('hidden');
    } else if (shamcashRadio && shamcashRadio.checked) {
      if (shamcashBox) shamcashBox.classList.remove('hidden');
      if (receiptBox) receiptBox.classList.remove('hidden');
    }
  }

  async function loadCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      cartData = await res.json();
      
      if (!cartItemsContainer) return;

      if (!cartData.items || cartData.items.length === 0) {
        cartItemsContainer.innerHTML = '<p class="text-xs text-gray-500">Your cart is empty.</p>';
        return;
      }

      cartItemsContainer.innerHTML = cartData.items.map(item => `
        <div class="flex items-center justify-between text-xs py-2">
          <div class="flex items-center gap-2">
            <img src="${item.image ? item.image + '&width=100' : ''}" alt="${item.title}" class="w-10 h-10 object-cover rounded border">
            <div>
              <p class="font-medium text-gray-900">${item.title}</p>
              <p class="text-gray-500">Qty: ${item.quantity}</p>
            </div>
          </div>
          <span class="font-medium text-gray-900">$${((item.final_line_price || item.line_price || 0) / 100).toFixed(2)}</span>
        </div>
      `).join('');

      updateTotals();
    } catch (err) {
      console.error('Error loading cart:', err);
    }
  }

  async function calculateShipping(country = 'Lebanon', province = '') {
    if (!shippingRatesContainer) return;

    shippingRatesContainer.innerHTML = '<p class="text-xs text-gray-500">Loading shipping options...</p>';
    
    const paymentMethodsContainer = codRadio ? codRadio.closest('.space-y-4') : null;
    if (paymentMethodsContainer) {
      const labels = paymentMethodsContainer.querySelectorAll('label');
      labels.forEach(lbl => {
        const hasCod = lbl.querySelector('#payment-cod');
        const hasWhish = lbl.querySelector('#payment-whish');
        const hasShamcash = lbl.querySelector('#payment-shamcash');

        if (country === 'Syria') {
          lbl.style.display = hasShamcash ? 'flex' : 'none';
        } else {
          lbl.style.display = (hasWhish || hasCod) ? 'flex' : 'none';
        }
      });

      if (country === 'Syria') {
        if (shamcashRadio) shamcashRadio.checked = true;
        if (whishRadio) whishRadio.checked = false;
        if (codRadio) codRadio.checked = false;
      } else {
        if (shamcashRadio && shamcashRadio.checked) {
          if (whishRadio) whishRadio.checked = true;
        }
      }
    }
    handlePaymentToggle();

    let html = `
      <div class="mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100 space-y-2">
        <p class="text-xs font-medium text-gray-700">Select Destination Country:</p>
        <div class="grid grid-cols-2 gap-2">
          <select id="ship-country" class="border rounded px-2 py-1 text-xs bg-white">
            <option value="Lebanon" ${country === 'Lebanon' ? 'selected' : ''}>Lebanon</option>
            <option value="Syria" ${country === 'Syria' ? 'selected' : ''}>Syria</option>
          </select>
          <input type="text" id="ship-city" placeholder="Enter City / Territory" value="${province}" class="border rounded px-2 py-1 text-xs bg-white">
        </div>
        <button type="button" id="update-shipping-btn" class="w-full bg-gray-900 text-white text-xs py-1.5 rounded font-medium hover:bg-gray-800 transition-all">Calculate Rates</button>
      </div>
    `;

    try {
      const query = `shipping_address[country]=${encodeURIComponent(country)}&shipping_address[province]=${encodeURIComponent(province)}`;
      const res = await fetch(`/cart/shipping_rates.json?${query}`);
      const data = await res.json();
      let rates = data.shipping_rates || [];

      if (rates.length === 0) {
        selectedShippingRate = country === 'Syria' ? 15.00 : 5.00;
        selectedShippingName = country === 'Syria' ? "Syrian Territories Standard Delivery" : "Standard Regional Delivery";
        
        html += `<p class="text-xs text-emerald-700 font-medium">Standard rate applied for ${country}: $${selectedShippingRate.toFixed(2)}</p>`;
        shippingRatesContainer.innerHTML = html;
        updateTotals();
      } else {
        html += rates.map((rate, idx) => {
          const ratePriceDollars = (parseFloat(rate.price) / 100); 
          return `
            <label class="flex items-center justify-between p-3 border rounded-lg cursor-pointer hover:border-emerald-600 transition-all bg-white mb-2">
              <div class="flex items-center gap-3">
                <input type="radio" name="shipping_rate" value="${ratePriceDollars}" data-name="${rate.name}" ${idx === 0 ? 'checked' : ''} class="text-emerald-600 shipping-radio">
                <span class="text-sm font-medium text-gray-800">${rate.name}</span>
              </div>
              <span class="text-sm font-semibold text-gray-900">$${ratePriceDollars.toFixed(2)}</span>
            </label>
          `;
        }).join('');

        shippingRatesContainer.innerHTML = html;

        selectedShippingRate = parseFloat(rates[0].price) / 100;
        selectedShippingName = rates[0].name;
        updateTotals();

        shippingRatesContainer.querySelectorAll('.shipping-radio').forEach(radio => {
          radio.addEventListener('change', (e) => {
            selectedShippingRate = parseFloat(e.target.value);
            selectedShippingName = e.target.getAttribute('data-name');
            updateTotals();
          });
        });
      }
    } catch (err) {
      selectedShippingRate = country === 'Syria' ? 15.00 : 5.00;
      selectedShippingName = `Standard Delivery (${country})`;
      html += `<p class="text-xs text-emerald-700 font-medium">Standard rate applied: $${selectedShippingRate.toFixed(2)}</p>`;
      shippingRatesContainer.innerHTML = html;
      updateTotals();
    }
  }

  // Single delegated listener for shipping calculation updates
  if (shippingRatesContainer) {
    shippingRatesContainer.addEventListener('click', (e) => {
      if (e.target && e.target.id === 'update-shipping-btn') {
        const countryEl = document.getElementById('ship-country');
        const cityEl = document.getElementById('ship-city');
        const c = countryEl ? countryEl.value : 'Lebanon';
        const p = cityEl ? cityEl.value : '';
        calculateShipping(c, p);
      }
    });
  }

  [whishRadio, shamcashRadio, codRadio].forEach(radio => {
    if (radio) radio.addEventListener('change', handlePaymentToggle);
  });

  if (submitOrderBtn) {
    submitOrderBtn.addEventListener('click', () => {
      if (!cartData || !cartData.items || cartData.items.length === 0) {
        alert('Your cart is empty.');
        return;
      }

      const customerNameInput = document.getElementById('customer-name');
      const customerPhoneInput = document.getElementById('customer-phone');
      const customerEmailInput = document.getElementById('customer-email');
      const customerAddressInput = document.getElementById('customer-address');
      const shippingTimeInput = document.getElementById('shipping-time');

      const customerName = customerNameInput ? customerNameInput.value.trim() : '';
      const customerPhone = customerPhoneInput ? customerPhoneInput.value.trim() : '';
      const customerEmail = customerEmailInput ? customerEmailInput.value.trim() : 'Not Provided';
      const customerAddress = customerAddressInput ? customerAddressInput.value.trim() : 'Not Provided';
      const shippingTime = shippingTimeInput ? shippingTimeInput.value.trim() : 'As soon as possible';

      if (!customerName || !customerPhone || !customerAddress) {
        alert('Please fill in your Full Name, Phone Number, and Street Address.');
        if (customerNameInput) customerNameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const countrySelectEl = document.getElementById('ship-country');
      const countrySelected = countrySelectEl ? countrySelectEl.value : 'Lebanon';
      const isPrepaid = countrySelected === 'Syria' || (whishRadio && whishRadio.checked) || (shamcashRadio && shamcashRadio.checked);

      if (isPrepaid && (!receiptFileInput || receiptFileInput.files.length === 0)) {
        alert('Please upload your payment transfer receipt before confirming your order.');
        if (receiptBox) {
          receiptBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          receiptBox.classList.add('border-red-400');
        }
        return;
      }

      const cityInput = document.getElementById('ship-city');
      const citySelected = cityInput && cityInput.value.trim() !== '' ? cityInput.value.trim() : 'Not Specified';

      let paymentMethod = 'Cash on Delivery';
      if (countrySelected === 'Syria' || (shamcashRadio && shamcashRadio.checked)) {
        paymentMethod = 'ShamCash (Pre-paid)';
      } else if (whishRadio && whishRadio.checked) {
        paymentMethod = 'Whish Money (Pre-paid)';
      }

      const orderNumber = 'AC-' + Math.floor(100000 + Math.random() * 900000);
      const subtotal = (cartData.items_subtotal_price || cartData.total_price || 0) / 100;
      const total = subtotal + selectedShippingRate;

      let message = `🛍️ *New Order: #${orderNumber}*\n\n`;
      message += `👤 *Customer Name:* ${customerName}\n`;
      message += `📞 *Phone Number:* ${customerPhone}\n`;
      message += `📧 *Email Address:* ${customerEmail}\n`;
      message += `🏠 *Street Address:* ${customerAddress}\n`;
      message += `🌍 *Destination City/Country:* ${citySelected}, ${countrySelected}\n`;
      message += `⏰ *Next Time to Ship:* ${shippingTime}\n\n`;
      message += `📦 *Order Items:*\n`;
      cartData.items.forEach((item, index) => {
        const linePriceDollars = ((item.final_line_price || item.line_price || 0) / 100).toFixed(2);
        message += `${index + 1}. *${item.title}* (Qty: ${item.quantity}) - $${linePriceDollars}\n`;
      });
      message += `\n📦 *Subtotal:* $${subtotal.toFixed(2)}`;
      message += `\n🚚 *Shipping (${selectedShippingName}):* $${selectedShippingRate.toFixed(2)}`;
      message += `\n💰 *Total Due:* $${total.toFixed(2)}`;
      message += `\n💳 *Payment Method:* ${paymentMethod}\n`;
      
      if (countrySelected === 'Syria' || (shamcashRadio && shamcashRadio.checked)) {
        message += `\n📲 *ShamCash Account Used:* 9b41e32f882109c1150498b77a1e2f91\n`;
      } else if (whishRadio && whishRadio.checked) {
        message += `\n📲 *Whish Account Used:* 47c28d780015082e405278c669c7b6f3\n`;
      }
      
      if (isPrepaid) {
        message += `\n📎 *Note:* Payment receipt attached/uploaded by customer.\n`;
        message += `\n⚠️ *Note to Receiver:* Please check that the correct amount has arrived in your wallet before fulfilling the order.\n`;
      }

      message += `\nPlease confirm my order!`;

      const whatsappUrl = `https://wa.me/96181141974?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    });
  }

  loadCart();
  calculateShipping('Lebanon', '');
});